import React , {useEffect, useRef, useState} from 'react'
import DataTable,  { createTheme  } from 'react-data-table-component';
import Axios from 'axios';
import { useContext } from 'react'
import AuthContext from './AuthContext';
import Modals from './Modals';
import Modals_Load from './Modals_Load';

import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'

import { useHistory } from "react-router-dom";

import ReactToPrint from "react-to-print";
import "./istyles.css";
import JsBarcode from 'jsbarcode';  // Import JsBarcode
import { QRCodeSVG } from 'qrcode.react'; // Import QRCodeSVG instead of default

import { format, parseISO, isAfter } from 'date-fns';

import FrmQEditProfile from './FrmQEditProfile'
import FrmQEditProfile_en from './FrmQEditProfile_en'


const formatPhoneNumber = (phone) => {
  if (!phone || phone.length !== 10) return phone; // ตรวจสอบว่าความยาวถูกต้อง
  return `${phone.slice(0, 3)}-${phone.slice(3, 6)}-${phone.slice(6, 10)}`;
};


const FullInvoice = React.forwardRef(({invoice}, ref) => { 
  
    const barcodeRef_taxid = useRef(null);  // barcode taxid
    const barcodeRef_ref11 = useRef(null); // barcode paymentcode + id_number + mod
    //const barcodeRef_ref111 = useRef(null); // barcode paymentcode + record_id + mod
    const barcodeRef_ref2 = useRef(null);  // barcode cost
    

    useEffect(() => {
      if (barcodeRef_taxid.current) {
        JsBarcode(barcodeRef_taxid.current, invoice.taxid, {
          format: 'CODE128',  // Use CODE128 format
          displayValue: true,  // Show the text below the barcode
          lineColor: '#000000',  // Barcode color
          width: 1,  // Width of barcode lines
          height: 41,  // Height of the barcode
          fontSize: 14,  // Font size of the barcode text
          margin: 10,  // Margin around the barcode        
        });
      }      
      if (barcodeRef_ref11.current) {
        JsBarcode(barcodeRef_ref11.current, invoice.ref11, {
          format: 'CODE128',  // Use CODE128 format
          displayValue: true,  // Show the text below the barcode
          lineColor: '#000000',  // Barcode color
          width: 1,  // Width of barcode lines
          height: 41,  // Height of the barcode
          fontSize: 14,  // Font size of the barcode text
          margin: 10,  // Margin around the barcode        
        });
      }
      /*
      if (barcodeRef_ref111.current) {
        JsBarcode(barcodeRef_ref111.current, invoice.ref111, {
          format: 'CODE128',  // Use CODE128 format
          displayValue: true,  // Show the text below the barcode
          lineColor: '#000000',  // Barcode color
          width: 1,  // Width of barcode lines
          height: 41,  // Height of the barcode
          fontSize: 14,  // Font size of the barcode text
          margin: 10,  // Margin around the barcode        
        });
      }
      */
      if (barcodeRef_ref2.current) {
        JsBarcode(barcodeRef_ref2.current, invoice.ref2, {
          format: 'CODE128',  // Use CODE128 format
          displayValue: true,  // Show the text below the barcode
          lineColor: '#000000',  // Barcode color
          width: 1,  // Width of barcode lines
          height: 41,  // Height of the barcode
          fontSize: 14,  // Font size of the barcode text
          margin: 10,  // Margin around the barcode        
        });
      }
  
    }, [invoice.ref11]);
    
    
  return (
    <div ref={ref} style={{ marginLeft: '20px' }}>   
    <br></br>
     <table border="0">
      <tr>
        <td><img height="99" src="./New_CU-Logo.jpg" width="85"/></td>
        <td style={{"height": "81px", "width": "382px"}}><b>Faculty of Commerce and Accountancy, Chulalongkorn University</b><br></br>
            <span style={{"font-size":"20pt","font-weight":"bold","height":"16px","width":"200px"}}>Payment Slip</span></td>   
        <td>&nbsp;&nbsp;&nbsp;</td>
        <td>&nbsp;&nbsp;&nbsp;</td>
        <td>&nbsp;&nbsp;&nbsp;</td>
        <td>&nbsp;&nbsp;&nbsp;</td>

        <td valign="middle" nowrap="">
									<div>Tax ID:
          <svg ref={barcodeRef_taxid}></svg> {/* SVG for rendering the barcode */}   
        </div></td>

      </tr>
     </table>

     <table border="0" width="90%">
      <tr>
        <td nowrap="" style={{"width": "178px"}}><strong>Passport No./ID number</strong></td>
        <td style={{"width":"199px"}}><span style={{"width":"162px"}}>{invoice.ID_Number}</span></td>

        <td></td>
        <td valign="middle" nowrap="" align="right" rowspan="4">
						<div>Ref 1:&nbsp; 
            <svg ref={barcodeRef_ref11}></svg>
            {/* invoice.login_type === '1' ? <svg ref={barcodeRef_ref11}></svg>:<svg ref={barcodeRef_ref111}></svg>*/}                                   
            </div></td>     

      </tr>
      <tr>
          <td style={{"width": "178px"}}><strong>Applicant name</strong></td>
          <td style={{"width":"199px"}}><span style={{"width":"168px"}}>{invoice.fullname}</span></td>        
      </tr>
      

      <tr>
					<td nowrap="" style={{"width": "178px"}}><strong>Mobile phone</strong></td>
					<td style={{"width":"199px"}}><span>{formatPhoneNumber(invoice.mobilephone)}</span></td>
			</tr>
     
      <tr>
        <td nowrap="" style={{"width": "178px"}}><strong>Program</strong></td>
        <td style={{"width":"199px"}}><span style={{"width":"168px"}}>{invoice.course}</span></td>
      </tr>
      
      <tr>
      <td nowrap="" style={{"width": "178px"}}><strong>Issued date</strong></td>
      <td style={{"width":"199px"}}><span style={{"width":"162px"}}>{invoice.startdate}</span></td>                 
      <td></td>
      <td valign="middle" nowrap="" align="right" rowspan="4">
			  <div>Ref 2:&nbsp;
          <svg ref={barcodeRef_ref2}></svg> {/* SVG for rendering the barcode */}   
        </div></td>	
      </tr>

      <tr>
					<td style={{"width": "178px"}}><strong>Application fee </strong>
					</td>
					<td style={{"width":"199px"}}><span style={{"width":"115px"}}>{invoice.cost.toLocaleString()}.00 baht</span></td>
				</tr>
				<tr>
					<td style={{"width": "178px"}}><strong>Last payment date</strong></td>
					<td style={{"width":"199px"}}><span>{invoice.enddate}</span></td>
				</tr>
				<tr>
					<td style={{"width": "178px"}}></td>
					<td style={{"width":"199px"}}></td>
				</tr>

     </table>

     

     
     <div style={{"width": "688px"}}>     
     <u><b>Note:</b></u><br></br>
     ----------------------------------------------------------<br></br>
		<b> Note for Applicants</b><br></br>
		----------------------------------------------------------<br></br>
    - Please bring this payment slip to make a payment at Counter Service (7-11) within application period.<br></br>
		- PLEASE Check Information on the receipt of payment after the payment that all information is correct.<br></br>
		( information will mark as payment for "MBA Program,Chulalongkorn University)"<br></br>
		- For Payment that paid later than period of Application will be invalid.<br></br>
		(Your application will be cancelled and the Office of CU-Best will not be refund in any case)<br></br>
		- Amount of Application fee must correct,in case of paid exceed than amount of application fee will not be refund.<br></br>
		- Applicants can check for status of payment 2-3 days after the payment. Test ID can be checked on later annoucement date 
		through CUBEST English application website at https://mba.cbs.chula.ac.th<br></br>
      
    </div>      
    </div>
  );
});

const FullPlaces = React.forwardRef(({invoice}, ref) => {  

 return (
  <div ref={ref} style={{ marginLeft: '20px' }}>   
  <br></br>
  
  <strong>                
    <span style={{ float: "right", marginRight: "15px" }}>{invoice.testid}</span>
    <br />
    <span style={{ float: "right", marginRight: "15px", opacity: 0.2 }}>Applicant ID</span>
</strong>



						<table  border="0" cellspacing="1" cellpadding="1" style={{"WIDTH": "648px", "HEIGHT": "65px"}}>
							<tr>
								<td rowSpan = "4" style={{"WIDTH": "197px"}}><img height="99" src="./New_CU-Logo.jpg" width="85"/></td>
                <tr>
                
                  <td align="center"><strong>แจ้งสถานที่สอบวิชาความถนัดทางธุรกิจ 
                              (CU-BEST)</strong></td>
                </tr>
                <tr>
											<td align="center"><strong>Examination Location 
														Announcement</strong></td>
								</tr>

                <tr>
											<td align="center"><strong>Chulalongkorn 
														University - Bussiness Entrance Scholastic Test</strong>
											</td>
								</tr>
                <tr>
											<td align="center"><strong> 
														English Program</strong>
											</td>
								</tr>

                <tr>
											<td align="center"><strong>Reference:&nbsp;</strong>
												<span>{invoice.CUBEST}</span></td>
								</tr>
								              
              </tr>
            </table>
            
            <br></br>
            <table style={{marginLeft: "10px","WIDTH": "648px", "HEIGHT": "65px"}} cellSpacing="1" cellPadding="1"  align="left" border="0">
            <tr>
								<td align="right" style={{"width": "129px"}}>Name:&nbsp;</td>
								<td align="left"><span style={{"width":"320px"}}>{invoice.fullname}</span></td>
						</tr>

            <tr>
								<td align="right" style={{"width": "129px"}}>Test Date:&nbsp;</td>
								<td align="left"><span style={{"width":"320px"}}>{invoice.testdate}&nbsp;&nbsp;9.00 am - 12.00 pm</span></td>
						</tr>
										<tr>
											<td align="right" style={{"width": "129px"}}>Applicant ID:&nbsp;</td>
											<td align="left"><span style={{"width":"320px"}}>{invoice.testid}</span></td>
										</tr>
										<tr>
											<td align="right" style={{"width": "129px"}}>Place:&nbsp;</td>
											<td align="left">
													<span id="lblPlace" style={{"width":"320px"}}>{invoice.testplace}</span></td>
										</tr>
										<tr>
											<td align="right" style={{"width": "129px"}}>Building:&nbsp;</td>
											<td align="left">
													<span style={{"width":"320px"}}>{invoice.testbuilding}</span></td>
										</tr>
										<tr>
											<td align="right" style={{"width": "129px"}}>Room:&nbsp;</td>
											<td align="left">
													<span style={{"width":"320px"}}>{invoice.testroom}</span></td>
										</tr>
										<tr>
											<td align="right" style={{"width": "129px"}}>Level:&nbsp;</td>
											<td align="left">
												<span style={{"width":"320px"}}>{invoice.testlevel}</span></td>
										</tr>
										

            </table>
            
  <div style={{ clear: "both" }}></div> {/* Forces tbl3 to a new line */}

 <table style={{ marginLeft: "10px","marginTop": "20px", "WIDTH": "237px"}} cellSpacing="1" cellPadding="1" border="0">
 <tr><td>            
<b><u>Faculty Map and Exam Room</u></b>
<a href="http://mba.cbs.chula.ac.th/wp-content/uploads/%E0%B9%81%E0%B8%9C%E0%B8%99%E0%B8%97%E0%B8%B5%E0%B9%88%E0%B8%84%E0%B8%93%E0%B8%B0%E0%B8%9A%E0%B8%B1%E0%B8%8D%E0%B8%8A%E0%B8%B52022Nov-1.jpg">[Faculty Map]</a>
<br></br>
<a href="http://mba.cbs.chula.ac.th/wp-content/uploads/mapfaculty_forpost.pdf">[ Map of Exam Room ] </a>
<br></br>
<div style={{ position: "relative", width: "100px", textAlign: "center" }}>
      <img src="./MBAmapbuilding.png" height="100" width="100"/>
      <div style={{ position: "absolute", bottom: "0", width: "100%", background: "white", fontSize: "12px" }}>
        map
      </div>
</div>

</td>
</tr>
</table>
<br></br>
<table style={{marginLeft: "10px","WIDTH": "648px", "HEIGHT": "65px"}} cellSpacing="1" cellPadding="1"  align="left" border="0">
            <tr>
							<td align="left">Master of Business Administration</td>
						</tr>
            <tr>
              <td align="left">Faculty of Commerce and</td>
            </tr>
            <tr>
              <td align="left">Accountancy,</td>
            </tr>
            <tr>
              <td align="left">Chulalongkorn University
              </td>
            </tr>
            <tr>
              <td align="left">
                Room&nbsp;506, 50th Memorial Bld.
              </td>
            </tr>
            <tr>
              <td align="left">Phayathai Rd. Bangkok 10330</td>
          </tr>
            <tr>
              <td align="left">Thailand</td>
            </tr>
            <tr>
              <td align="left">Tel. (66)-2218-5717 to 9 
              </td>
            </tr>
           
            <tr>
              <td align="left">Website:&nbsp;<a href="https://mba.cbs.chula.ac.th">https://mba.cbs.chula.ac.th</a></td>
            </tr>

            </table>

  

</div>
);
});


const FrmApplication_en = () => {

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const fullInvoiceRefs = useRef([]);
  const fullPlacesRefs = useRef([]);
    
  const modalsRef = useRef(null);
  const modalsRef_load = useRef(null);
  const history = useHistory();
  
  const {token,settoken} = useContext(AuthContext);

  const [q, setq] = useState("");
  
  const [data,setdata] = useState([]);
  const [data2,setdata2] = useState([]);  
    
  const [searchcolumns,setsearchcolumns] = useState(["ref","test_language"]);
  const [searchcolumns2,setsearchcolumns2] = useState(["CUBEST","test_language"]);
  
  const [isedit,setisedit] = useState("0");

  const [pending, setPending] = useState(true);
  const [pending2, setPending2] = useState(true);

  const {gclang} = useContext(AuthContext);

  const {gnuserid} = useContext(AuthContext);

  const [Qlang,setQlang] = useState({        
    lang:gclang,
    ID_Number:gnuserid    
  });

  const [isprintinvoice, setisprintinvoice] = useState([]);
  const [isprintplace, setisprintplace] = useState([]);

   const [QEdittemplate,setQEdittemplate] = useState({        
      lang:gclang,  
      ID_Number:gnuserid,
      CUBEST:'',      
      LeadName:'',      
      First_Name_Thai:'',
      Last_Name_Thai:'',
      First_Name_Eng:'',
      Last_Name_Eng:'',
      Birth_Date:'',    
      Sex:'',
      ID_Issue_Place:'',
      ID_Expiry_Date:'',    
      Email:'',  
      Address1:'',
      Telephone:'',
      MobilePhone:'',                
      Target_Program:'',
      Target_ProgramArr:[] 
    });

  
  useEffect(() => {
   
    async function fetchData() { 

      modalsRef_load.current.fnshow();  
      const response2 = await Axios.post('/qnewprogram',Qlang,{               
          'withCredentials': false,     
          headers:{
              "x-access-token": token,              
              'Cache-Control': 'no-cache',
              'Pragma': 'no-cache',
              'Expires': '0',        
            }});
      
      modalsRef_load.current.fnclose();            
      let output2 = response2.data; 
      console.log('tid2',output2);      
      setPending(false);                  
      setdata(output2)              
                                
    }

    async function fetchData2() { 
      
      const response3 = await Axios.post('/qapplyprogram',Qlang,{               
          'withCredentials': false,     
          headers:{
              "x-access-token": token,              
              'Cache-Control': 'no-cache',
              'Pragma': 'no-cache',
              'Expires': '0',        
            }});
            
      let output3 = response3.data; 
      console.log('tid3',output3);
      
      setPending2(false);                  
      setdata2(output3);
            
      const invoiceArray = [];
      const placeArray = [];

      for (let x = 0; x < output3.length; x++) {
        if (output3[x].AnnouceTestPlace === "N") {
          invoiceArray.push(true);
          placeArray.push(false);
        } else if (output3[x].AnnouceTestPlace === "Y") {
          invoiceArray.push(false);
          placeArray.push(true);
        }
      }

      setisprintinvoice(invoiceArray);
      setisprintplace(placeArray);
            
      fullInvoiceRefs.current = output3.map((_, i) => fullInvoiceRefs.current[i] || React.createRef());
      fullPlacesRefs.current =  output3.map((_, i) => fullPlacesRefs.current[i] || React.createRef());
      
    }
   
    fetchData();  // show new program    
    fetchData2();  // show invoice data    
         
    },[token]);

  
  const fncallback = (e,iserror) => {
    e.preventDefault(); 
    if(iserror === true)
    {
      modalsRef.current.fnclose();                                    
      history.push('/login');
    }
    else{
      modalsRef.current.fnclose();        
      //modalsRef.current.fnshow('Output','กรุณากรอกข้อมูลก่อนครับ',false,false,"1");                             
    }
    
  }

  const calculateMod10CheckDigit = (barcode) => {
    // for print barcode cardid
    barcode = barcode.trim();
    const barcodeLength = barcode.length;
  
    let sumOdd = 0;
    for (let i = 0; i < barcodeLength; i += 2) {
      sumOdd += parseInt(barcode[i], 10);
    }
  
    const sumOddTimesThree = sumOdd * 3;
  
    let sumEven = 0;
    for (let i = 1; i < barcodeLength; i += 2) {
      sumEven += parseInt(barcode[i], 10);
    }
  
    const totalSum = sumOddTimesThree + sumEven;
    const lastDigit = totalSum % 10;
  
    return lastDigit === 0 ? 0 : 10 - lastDigit;
  };

  const getFormattedDate = () => {   
    return format(new Date(), 'yyyy-MM-dd'); // Get the current date in 'YYYY-MM-DD' format
  };
  
    const handleprintinvoice  = async (e,row) =>{
      //1234567890121  //gnuserid or cardid
      //tidtid
      e.preventDefault(); 
      // Find the index of the row
      const rowIndex = data2.findIndex(item => item === row);
      console.log('Row Index:', rowIndex);
      console.log(data2);
      
      let myoutput = calculateMod10CheckDigit(data2[rowIndex].ref1); // for print barcode
      let myoutput2 = data2[rowIndex].ref1 + myoutput.toString();
      console.log(myoutput2);

       
      const currentDate = parseISO(getFormattedDate()); // Parse the formatted string into a Date object
      const targetDate = parseISO(data2[rowIndex].enddate); // Parse the target date into a Date object
      
      console.log('currentDate',currentDate);
      console.log('targetDate',targetDate);
      
      if (isAfter(currentDate, targetDate)) {
        alert("don't have invoice button");
      }
      else{
        alert("have invoice button");
      }
   
      
    }

     
    const fntest = async (e) => {
      // save in edit template form
      e.preventDefault(); 

      console.log(QEdittemplate);    
          
      const response = await Axios.post('/edittargetprogram', QEdittemplate, {               
        'withCredentials': false,     
        headers:{
            "x-access-token": token,              
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',        
      }});
      let output = response.data; 
            
      if(output[0].issuccess === 1){
        //alert(`${output[0].msg}`);  
        modalsRef.current.fnshow('Output',`${output[0].msg}`,false,false,"1");         
        
        settoken((a) => (output[0].token));
        
        handleClose();                       
        
      }
      else{
        alert(`${output[0].msg}`);
      }


      
    }
    const handleonQEdit  = async (e,row) =>{  
      e.preventDefault();
      // Find the index of the row
      const rowIndex = data2.findIndex(item => item === row);
      console.log('Row Index:', rowIndex);       
      //data2[rowIndex].ref1
      
      setQEdittemplate((p) => ({...p
        ,lang:gclang
        ,ID_Number:data2[rowIndex].ID_Number
        ,CUBEST:data2[rowIndex].CUBEST
        ,LeadName:data2[rowIndex].LeadName        
        ,First_Name_Thai:data2[rowIndex].First_Name_Thai
        ,Last_Name_Thai:data2[rowIndex].Last_Name_Thai
        ,First_Name_Eng:data2[rowIndex].First_Name_Eng
        ,Last_Name_Eng:data2[rowIndex].Last_Name_Eng
        ,Birth_Date:data2[rowIndex].Birth_Date
        ,Sex:data2[rowIndex].Sex
        ,ID_Issue_Place:data2[rowIndex].ID_Issue_Place
        ,ID_Expiry_Date:data2[rowIndex].ID_Expiry_Date
        ,Email:data2[rowIndex].Email
        ,Address1:data2[rowIndex].Address1
        ,Telephone:data2[rowIndex].telephone
        ,MobilePhone:data2[rowIndex].mobilephone
        ,Target_Program:data2[rowIndex].Target_Program,}));     
            
      handleShow();
    
    }

    const HandlerApply = async (e,ref,test_language,Program) =>{    
      //1234567890121      
      e.preventDefault(); 
      let myjsondata = {};
      
      myjsondata.Program =Program;
      myjsondata.CUBEST = ref;
      myjsondata.Test_language = test_language;
      myjsondata.ID_Number = gnuserid;
      console.log('Apply Program ja',myjsondata);
      
        
      const response = await Axios.post('/applyprogram', myjsondata,{               
        'withCredentials': false,     
        headers:{
            "x-access-token": token,              
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',        
      }});
      let output = response.data; 
      //console.log(output);
      
      if(output[0].issuccess === 1){
        //alert(`${output[0].msg}`);  
        modalsRef.current.fnshow('Output',`${output[0].msg}`,false,false,"1");         
        settoken((a) => (output[0].token));
        
      }
      else{
        alert(`${output[0].msg}`);
      }
   
      
    }
   

    const columns = [
      {
        name: 'Program Name',
        selector: row => row.program,
        sortable: true,
        
      },
      {
          name: 'Ref',
          selector: row => row.ref,
          sortable: true,
          
      },
      {
        name: 'Test Date',
        selector: row => row.testdate,
        sortable: true,
        
      },
      {
      name: 'Start Date',
      selector: row => row.startdate,
      sortable: true,
      
      },
      {
        name: 'End Date',
        selector: row => row.enddate,
        sortable: true,
        
      },

      {
        name: 'Expiry Date',
        selector: row => row.expiry_date,
        sortable: true,        
      },
       
      {
        name: "Actions",                    
        cell:(row)=><button onClick={(e) => HandlerApply(e,row.ref,row.test_language,row.program)}>Apply</button>,                
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      }
  ];

  
  const columns2 = [
    
    {
      name: 'Program Name',
      selector: row => row.Program,
      sortable: true,
      
    },
    {
        name: 'Ref',
        selector: row => row.CUBEST,
        sortable: true,
        
    },
    {
      name: 'Application Status',
      selector: row => row.StatusDescription,
      sortable: true,
      
    },
    {
      name: 'Test Date',
      selector: row => row.testdate,
      sortable: true,
      
    },
    {
    name: 'Start Date',
    selector: row => row.startdate,
    sortable: true,
    
    },
    {
      name: 'End Date',
      selector: row => row.enddate,
      sortable: true,
      
    },

    {
      name: 'Expiry Date',
      selector: row => row.expiry_date,
      sortable: true,        
    }, 
  
    {
      name: "Actions",
      cell: (row, index) => {                
        return (            
          <span>
            &nbsp;&nbsp;
            <ReactToPrint
              trigger={() => (
                <button disabled={!isprintinvoice[index]}>Print Payment Slip</button>
              )}
              content={() => fullInvoiceRefs.current[index].current}
            />&nbsp;&nbsp;
            <ReactToPrint
              trigger={() => (
                <button disabled={!isprintplace[index]}>Print Test Place</button>
              )}
              content={() => fullPlacesRefs.current[index].current}
            />&nbsp;&nbsp;
            <button onClick={(e) => handleonQEdit(e,row)}>View/Edit Application</button>&nbsp;&nbsp;
            {/* Hidden Component for Printing */}
            <div style={{ display: 'none' }}>
              <FullInvoice ref={fullInvoiceRefs.current[index]} invoice={row} />
            </div>
            <div style={{ display: 'none' }}>
              <FullPlaces ref={fullPlacesRefs.current[index]} invoice={row} />
            </div>
          </span>
        );
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    }



  ];

  const customStyles = {
      headRow: {
        style: {
          border: 'none',
        },
      },
      headCells: {
        style: {
          fontSize: '14px',
          fontWeight: '600',
          //textTransform: 'uppercase',        
          color: '#202124',        
        },
      },
      rows: {
        highlightOnHoverStyle: {
          backgroundColor: 'rgb(230, 244, 244)',
          borderBottomColor: '#FFFFFF',
          borderRadius: '25px',
          outline: '1px solid #FFFFFF',
        },
      },
      pagination: {
        style: {
          border: 'none',
        },
      },
    };
  
  function search(rows){
    const columns = rows[0] && Object.keys(rows[0]); // เอา ทุก columns
            
    return rows.filter( (row) =>         
      
      // ค้นหา แบบ ทุก columns
      //columns.some((column) => row[column].toString().toLowerCase().indexOf(q.toLowerCase()) > -1)  
      
      // ค้นหา แบบ กำหนดว่าจะเอา Column ไหนบ้าง
      searchcolumns.some((column) => row[column].toString().toLowerCase().indexOf(q.toLowerCase()) > -1)
      
      // ค้นหา แบบ Manual
      //row.title.toLowerCase().indexOf(q.toLowerCase()) > -1 ||
      //row.year.toLowerCase().indexOf(q) > -1 
    
    );
  }

  function search2(rows){                
    return rows.filter( (row) =>                                
      searchcolumns2.some((column) => row[column].toString().toLowerCase().indexOf(q.toLowerCase()) > -1)              
    );
  }
  


  return (    
    <>
        <Modal  
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                fullscreen={true}
        > 

        <Modal.Header>        
          <Modal.Title>Edit Profile Form</Modal.Title>        
        </Modal.Header>
              
        <Modal.Body>
       
          <FrmQEditProfile_en QEdittemplate={QEdittemplate} setQEdittemplate={setQEdittemplate} /> 
        
        </Modal.Body>
        <Modal.Footer>
        <Button variant="success" onClick={fntest}>Save</Button>        
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          
        </Modal.Footer>
      </Modal> 

      <Modals_Load ref={modalsRef_load} />
      <Modals lctitle='' lcbody='' fullscreen='false' fncallback={fncallback} ref={modalsRef} />
      <br></br>      
        <div className="card" style={{width: '100%;'}}>      
        <div className="card-body">
        
          <div className="row mb-3">  
            <h4><i class="fa fa-table" aria-hidden="true"></i>&nbsp;Application</h4>
          </div>

          <div class="mb-1 row">
            <h5>Available Test Date :</h5>
          </div>
        
          <div class="row">  
            <div class="col-sm-12 my-1">
                <div class="card">
                    <div class="card-body">  
                        <div className="row justify-content-around">
                            <div className="col-sm-12 col-item">   
                                <div class="card-text text-start">
                                Please select Test Date you want, then click 'Apply' Button :
                                </div> 
                            </div>
                            {/* <div className="col-sm-2 col-item">   
                                <div class="card-text text-end">
                                    <div class="d-flex flex-row">
                                        <div class="p-2">
                                            <input type="text" placeholder="ค้นหา" className="form-control" id='txt1' value={q} onChange={(e) => setq(e.target.value)}/>
                                        </div>                                                                                                                      
                                    </div>
                                </div>                            
                            </div> */}
                        </div>
                                             

                    <DataTable
                            // title="Patient Lists"
                            columns={columns}
                            //data={data}            
                            data={search(data)}
                            //defaultSortField="id"            
                            //defaultSortAsc={true}
                            onRowClicked={ (rowData) => {              
                            console.log(rowData.ref);
                            }}   
                            // selectableRows                             
                            pagination 
                            fixedHeader            
                            fixedHeaderScrollHeight="2000px"                            
                            highlightOnHover
                            pointerOnHover            
                            striped
                            responsive                     
                            customStyles={customStyles}
                            progressPending={pending}
                            paginationRowsPerPageOptions={[10,25,50,100,1000000]}
                                                
                        />
                       
                       
                    </div>
                </div>
            </div>
          </div>       
  
          <div class="mb-5 row">
            
          </div>

          <div class="mb-1 row">
            <h5>Your Application :</h5>
          </div>
        
          <div class="row">  
            <div class="col-sm-12 my-">
                <div class="card">
                    <div class="card-body">                                               

                    <DataTable
                            // title="Patient Lists"
                            columns={columns2}
                            //data={data}            
                            data={search2(data2)}
                            //defaultSortField="id"            
                            //defaultSortAsc={true}
                            onRowClicked={ (rowData) => {              
                            console.log(rowData.ref);
                            }}   
                            // selectableRows                             
                            pagination 
                            fixedHeader            
                            fixedHeaderScrollHeight="2000px"                            
                            highlightOnHover
                            pointerOnHover            
                            striped
                            responsive                     
                            customStyles={customStyles}
                            progressPending={pending2}
                            paginationRowsPerPageOptions={[10,25,50,100,1000000]}
                                                
                        />
                       
                       
                    </div>
                </div>
            </div>
          </div>   

      
        </div>
      </div>
    
    </>          

  )
}

export default FrmApplication_en